export default "__VITE_ASSET__B1b$D7gf__"